{
  "de": {
    "aiDocumentQa": {
      "buttons": {
        "chooseFile": "Datei auswählen",
        "loadMore": "Mehr laden"
      },
      "confirm": {
        "deleteDocumentChat": {
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Das Dokument wird mit dem gesamten Chatverlauf dauerhaft gelöscht.",
          "title": "Dokumenten-Chat löschen?"
        }
      },
      "hints": {
        "documentIsBeingProcessed": "Dokument wird analysiert...",
        "dropFile": "PDF hier reinziehen oder",
        "fileLimit": "(maximal 10MB)"
      },
      "labels": {
        "words": "{count} Wörter"
      },
      "paragraphs": {
        "intro": "Lade ein Dokument hoch und lass dir von der KI die Inhalte zusammenfassen, Frage-Antwort Paare für Lernkarten anlegen oder Fragen zum Inhalt beantworten. Beachte: Bilder und Tabellen in Dokumenten sind für die KI nicht lesbar."
      },
      "statusMessages": {
        "indexing": "Hintergrundwissen wird indiziert",
        "indexingStatus": "Indizierung"
      }
    }
  }
}
